import { PDFDocumentView as AntdPDFDocumentView } from "@empglabs/backoffice-ui-kit"

const PDFDocumentView = props => {
  return <AntdPDFDocumentView {...props} />
}

export default PDFDocumentView
